(function () {
  'use strict';

  // Make the FIRST click on a "Notify me when available" button open Appikon's popup.
  //
  // Our notify buttons carry the `SI_trigger` class. On the first click Appikon's document-level handler builds a
  // popover for the product (replacing the page's #SI_frame and rendering its form into it after a 50ms defer) and
  // asks it to show 13ms later -- before that render, so the frame is left hidden and nothing appears. Every later
  // click reuses the cached, rendered popover and works. Shoppers read that as "the Notify button isn't working".
  //
  // So: after a click, watch for that state -- the form rendered into the frame but the frame still hidden -- and
  // click once more the moment it appears (~50ms in). Appikon's handler always shows (never toggles), so the retry
  // cannot close a popup that opened by itself, and when the popup shows on its own (every click after the first)
  // the watch simply stops. If Appikon is not on the page at all, nothing renders and the watch gives up.
  //
  // Backdrop: Appikon shows the form at once but only adds the dark backdrop (`body.fadein` inside its frame) 130ms
  // later, then fades it in over 150ms, so the form pops in alone first. Its frame is display:none whenever the
  // popup is closed, so the backdrop colour is pinned on the frame's body for good (copied from Appikon's own
  // `body.fadein` rule, so a colour change in the Appikon dashboard still applies) -- form and backdrop then appear,
  // and disappear, together. Appikon renders the form into the frame once per popover, so the style sticks.

  if (window.__kjpNotifyFirstClickInit) return;
  window.__kjpNotifyFirstClickInit = true;

  var SELECTOR = '.kjp-notify-button.SI_trigger, .product-sticky-bar__notify.SI_trigger';
  var POLL_MS = 40;
  var GIVE_UP_MS = 2000;
  var RETRYING_ATTR = 'data-kjp-notify-retry';
  var BACKDROP_STYLE_ID = 'kjp-si-backdrop';

  function popupFrame() {
    return document.getElementById('SI_frame');
  }

  // Appikon hides the frame from an injected stylesheet, not an inline style, so read the computed value.
  function popupShowing(frame) {
    return !!frame && window.getComputedStyle(frame).display !== 'none';
  }

  // The first-click popover renders its form into a fresh, blank frame after a 50ms defer.
  function popupRendered(frame) {
    try {
      var doc = frame && frame.contentDocument;
      return !!(doc && doc.querySelector('form'));
    } catch (e) {
      return false;
    }
  }

  function fadeinBackground(doc) {
    for (var i = 0; i < doc.styleSheets.length; i++) {
      var rules;
      try {
        rules = doc.styleSheets[i].cssRules;
      } catch (e) {
        continue;
      }

      for (var j = 0; j < rules.length; j++) {
        if (rules[j].selectorText === 'body.fadein' && rules[j].style.backgroundColor) return rules[j].style.backgroundColor;
      }
    }

    return null;
  }

  // No-op until the form is rendered, once the style is in, or if Appikon's backdrop rule ever changes shape.
  function pinBackdrop(frame) {
    try {
      var doc = frame && frame.contentDocument;
      if (!doc || !doc.querySelector('form') || doc.getElementById(BACKDROP_STYLE_ID)) return;

      var background = fadeinBackground(doc);
      if (!background) return;

      var style = doc.createElement('style');
      style.id = BACKDROP_STYLE_ID;
      style.textContent = 'html body { background-color: ' + background + ' !important; transition: none !important; }';
      (doc.head || doc.documentElement).appendChild(style);
    } catch (e) {}
  }

  function retry(button) {
    button.setAttribute(RETRYING_ATTR, '');
    try {
      button.click();
    } finally {
      button.removeAttribute(RETRYING_ATTR);
    }
  }

  // Capture phase, so an already-built popover gets its backdrop before Appikon's (bubbling) handler shows it.
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest(SELECTOR)) pinBackdrop(popupFrame());
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!button || button.hasAttribute(RETRYING_ATTR)) return;

    var startedAt = Date.now();

    (function watch() {
      setTimeout(function () {
        var frame = popupFrame();
        pinBackdrop(frame);
        if (popupShowing(frame) || !button.isConnected) return;

        if (window.SI && popupRendered(frame)) {
          retry(button);
          return;
        }

        if (Date.now() - startedAt < GIVE_UP_MS) watch();
      }, POLL_MS);
    })();
  });
})();
